export default {
	default: "admin",
	routes: {
		admin: {
			routes: [
				{
					icon: "mdi-view-dashboard",
					title: "dashboard",
					to: "main-dashboard"
				},
				{
					icon: "mdi-account-group",
					title: "users",
					to: "users-view"
				},
				{
					icon: "mdi-chart-tree",
					title: "projects",
					to: "projects-view"
				},
				{
					icon: "mdi-cash-usd",
					title: "coupons",
					to: "coupons-view"
				},
				{
					icon: "mdi-key",
					title: "keys",
					to: "passports-view"
				},
				{ title: "profile", to: "user-profile", icon: "mdi-account" }
			]
		},
		customer: {
			routes: [
				{ title: "הרכישות שלי", to: "purchase-history", icon: "mdi-cart" },
				{ title: "פרופיל", to: "user-profile", icon: "mdi-user" }
			]
		}
	}
};
